import { Navigate, useLocation } from "react-router-dom";
import { useCrmAuth } from "./CrmAuthContext";

export function canAccess(user, section) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (section === "__admin__") return false;
  if (!section) return true;
  return (user.permissions || []).includes(section);
}

export function SectionGuard({ section, children }) {
  const { user } = useCrmAuth();
  const location = useLocation();
  if (user === undefined) {
    return <div className="crm-shell min-h-screen flex items-center justify-center text-[#A8A39D]">Loading…</div>;
  }
  if (user === null) return <Navigate to="/crm/admin/login" state={{ from: location }} replace />;
  if (!canAccess(user, section)) return <Navigate to="/crm/admin" replace />;
  return children;
}
